export default "__VITE_ASSET__07b9f16a__"